<template>
  <tr v-if="score">
    <slot></slot>
    <td class="text-right"  style="width:120px">
      <score-view2 :score="score.perform"  @view-result="onViewPerformWritingTest"/>
    </td>
    <td class="text-right"  style="width:120px">
      <score-view2 :score="score.writing" @view-result="onViewResultWritingTest"/>
    </td>
    <td class="text-right" style="width:60px">
      <score-view :score="score.attitude"  test="태도" @view-result="onViewResultAttitudeTest"/>
    </td>
    <td class="text-right" style="width:60px">
      <score-view :score="score.portfolio" test="포트폴리오" @view-result="onViewResultPortfolioTest"/>
    </td>
  </tr>
</template>
<script>
import {} from 'mdbvue'
import Scores from '@/models/test/Scores'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import ScoreView from './ScoreView.vue'
import ScoreView2 from './ScoreView2.vue'
export default {
  name: 'StaffStudentTestScore',
  components: { ScoreView, ScoreView2 },
  props: ['training', 'student', 'code'],
  data: () => ({
    TAG: 'StaffStudentTestScore',
    score: undefined
  }),
  computed: {
    query () {
      return {
        training: this.training,
        code: this.code,
        student: this.student
      }
    }
  },
  methods: {
    async load () {
      if (!this.training || !this.student) return
      this.score = await Scores.getTestScore({ training: this.training, student: this.student, code: this.code })
    },
    onViewPerformWritingTest () {
      this.$router.push({
        name: 'StaffPerformTestView',
        query: this.query
      })
    },
    onViewResultAttitudeTest () {
      this.$router.push({
        name: 'StaffAttitudeTestView',
        query: this.query
      })
    },
    onViewResultWritingTest (seq) {
      this.$router.push({
        name: 'StaffWritingTestView',
        query: {
          ...this.query,
          seq
        }
      })
    },
    onViewResultPortfolioTest () {
      this.$router.push({
        name: 'StaffPortfolioTestView',
        query: this.query
      })
    }
  },
  watch: { student: 'load' },
  created () { this.load() }
}
</script>
